export const NAME_REGEX = /^[a-zA-Z'-]+$/;
